(() => {
  const init = app => {
    if (app.dataset.initialized) return;
    app.dataset.initialized = 'true';
    app.querySelectorAll('.sr-extras .table-wrap').forEach(wrapper => {
      wrapper.setAttribute('role','region');
      wrapper.setAttribute('tabindex','0');
      wrapper.setAttribute('aria-label',wrapper.closest('section')?.querySelector('h2')?.textContent || document.title);
    });
    const index = app.querySelector('[data-recipe-index]');
    const form = app.querySelector('[data-recipe-filters]');
    const grid = app.querySelector('[data-recipe-grid]');
    const cards = Array.from(app.querySelectorAll('[data-recipe-card]'));
    const details = Array.from(app.querySelectorAll('[data-recipe-detail]'));
    const number = new Intl.NumberFormat(document.documentElement.lang, {maximumFractionDigits: 1});
    const normalize = text => text.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const sort = app.querySelector('[data-recipe-sort]');
    const filter = (updateUrl = true) => {
      if (!form) return;
      const data = new FormData(form);
      const query = normalize(String(data.get('rq') || '').trim());
      const limit = Number(data.get('minutes')) || Infinity;
      const timeKind = data.get('time_kind') === 'prep' ? 'prep' : 'total';
      const diet = String(data.get('diet') || '');
      const category = String(data.get('category') || '');
      let visible = 0;
      cards.forEach(card => {
        const match = query.split(/\s+/).every(word => normalize(card.dataset.search).includes(word)) && Number(card.dataset[timeKind]) <= limit && (!diet || card.dataset.diets.split(' ').includes(diet)) && (!category || card.dataset.category === category);
        card.hidden = !match;
        if (match) visible += 1;
      });
      const sorted = [...cards].sort((a,b) => sort?.value === 'quick' ? Number(a.dataset.total) - Number(b.dataset.total) : sort?.value === 'name' ? a.dataset.title.localeCompare(b.dataset.title, document.documentElement.lang) : b.dataset.date.localeCompare(a.dataset.date));
      sorted.forEach(card => grid.append(card));
      const count = app.querySelector('[data-result-count]');
      if (count) count.textContent = String(visible);
      const empty = app.querySelector('[data-recipe-empty]');
      if (empty) empty.hidden = visible > 0;
      if (updateUrl && location.protocol !== 'about:') {
        const url = new URL(location.href);
        ['rq','minutes','time_kind','diet','category','sort'].forEach(key => url.searchParams.delete(key));
        for (const [key,value] of data) if (value && !(key === 'time_kind' && value === 'total')) url.searchParams.set(key,value);
        if (sort?.value && sort.value !== 'recent') url.searchParams.set('sort',sort.value);
        history.replaceState(null,'',url);
      }
    };
    if (form) {
      const url = new URL(location.href);
      ['rq','minutes','time_kind','diet','category'].forEach(key => { const field = form.elements.namedItem(key); if (field && url.searchParams.has(key)) field.value = url.searchParams.get(key); });
      if (sort && url.searchParams.has('sort')) sort.value = url.searchParams.get('sort');
      form.addEventListener('submit',event => {event.preventDefault(); filter();});
      form.addEventListener('input',() => filter());
      form.addEventListener('change',() => filter());
      sort?.addEventListener('change',() => filter());
      app.querySelectorAll('[data-reset-filters]').forEach(button => button.addEventListener('click',() => {form.reset(); if(sort)sort.value='recent'; filter(); form.querySelector('input')?.focus();}));
      filter(false);
    }
    let active = null;
    const route = () => {
      if (!index || !details.length) return;
      const target = decodeURIComponent(location.hash.replace(/^#recipe=/,''));
      const next = location.hash.startsWith('#recipe=') ? details.find(item => item.dataset.recipeDetail === target) : location.hash.startsWith('#r-') ? details.find(item => location.hash.startsWith('#r-'+item.dataset.recipeDetail+'-')) : null;
      index.hidden = Boolean(next);
      details.forEach(item => {item.hidden = item !== next;});
      if (next && next !== active) {
        next.querySelectorAll('.sr-hero img').forEach(img => {img.loading='eager';});
        next.querySelector('h1')?.focus({preventScroll:true});
        if (location.hash.startsWith('#r-')) document.getElementById(location.hash.slice(1))?.scrollIntoView();
        else window.scrollTo({top:0,behavior:'instant'});
      }
      if (!next && active) { window.scrollTo({top:0,behavior:'instant'}); index.querySelector('h1')?.focus({preventScroll:true}); }
      active = next;
    };
    window.addEventListener('hashchange',route);
    route();
    app.addEventListener('click',event => {
      const internal = event.target.closest('a[href^="#"]');
      if (internal) {
        event.preventDefault();
        const hash = internal.getAttribute('href');
        location.hash = hash;
        route();
        if (!hash.startsWith('#recipe=')) document.getElementById(hash.slice(1))?.scrollIntoView({block:'start'});
      }
      const print = event.target.closest('[data-print]');
      if (print) window.print();
      const button = event.target.closest('[data-serving-change]');
      if (button) {
        const detail = button.closest('[data-recipe-detail]');
        const input = detail.querySelector('[data-servings]');
        input.value = String(Math.max(1,Math.min(100,Number(input.value) + Number(button.dataset.servingChange))));
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }
      const cooking = event.target.closest('[data-cooking]');
      if (cooking) {
        const detail = cooking.closest('[data-recipe-detail]');
        const state = detail.classList.toggle('sr-cooking');
        cooking.setAttribute('aria-pressed',String(state));
        if (state) detail.querySelector('.sr-method').scrollIntoView({block:'start'});
      }
    });
    const scaleIngredients = event => {
      if (!event.target.matches('[data-servings]')) return;
      if (event.type === 'input' && !event.target.value) return;
      const input = event.target;
      const detail = input.closest('[data-recipe-detail]');
      const entered = input.value === '' ? Number(detail.dataset.baseServings) : input.valueAsNumber;
      const servings = Math.round(Math.max(1,Math.min(100,Number.isFinite(entered) ? entered : Number(detail.dataset.baseServings))));
      input.value = String(servings);
      const ratio = servings / Number(detail.dataset.baseServings);
      detail.querySelectorAll('[data-quantity]').forEach(el => {el.textContent = number.format(Number(el.dataset.quantity) * ratio)+' '+el.dataset.unit;});
    };
    app.addEventListener('input',scaleIngredients);
    app.addEventListener('change',scaleIngredients);
  };
  document.querySelectorAll('[data-recipes-app]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-recipes-app]').forEach(init));
})();
